import React, {Component} from "react";
import {Col, Container, Row, Button} from "react-bootstrap";
import RemotingService from "../../../../../services/remoting-service/RemotingService";
import dialog from "../../../../../components/dialog/Dialog";
import ObservationsModalV2 from "../observation/ObservationsModalV2";
import ViewObservationsModalV2 from "../observation/ViewObservationsModalV2";
import ResubmissionsModalV2 from "../resubmission/ResubmissionsModalV2";
import VersionModalV2 from "../component/VersionModalV2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default class ReferralObsXMLsTab extends Component {

    constructor(props) {
        super(props);
        
        this.state = {};
    }

    openObservationsDialog = () => {
        const { referral, readOnly } = this.props;
        if (referral && referral.id) {
            dialog({
                title: "Observations",
                component: <ObservationsModalV2 referralId={referral.id} readOnly={readOnly}/>
            });
        }
    }

    openResubmissionsDialog = () => {
        const { referral } = this.props;
        if (referral && referral.id) {
            dialog({
                title: "Resubmissions",
                component: <ResubmissionsModalV2 referralId={referral.id}/>
            });
        }
    }

    openObservationFromInsuranceDialog = () => {
        const { referral } = this.props;
        if (referral && referral.id) {
            RemotingService.getRemoteCall(
                `api/insurance/coordinator/v2/referral/${referral.id}/observation-from-insurance`, 
                null, 
                observations => {
                    dialog({
                        title: "Observations From Insurance",
                        component: <ViewObservationsModalV2 observations={observations}/>
                    });
                }
            );
        }
    }

    openRequestVersionsDialog = () => {
        const { referral } = this.props;
        if (referral && referral.requestVersionList) {
            dialog({
                title: "Request Versions",
                component: <VersionModalV2 versions={referral.requestVersionList}/>
            });
        }
    }

    openAuthorizationVersionsDialog = () => {
        const { referral } = this.props;
        if (referral && referral.authorizationVersionList) {
            dialog({
                title: "Authorization Versions",
                component: <VersionModalV2 versions={referral.authorizationVersionList}/>
            });
        }
    }


    render() {
        const { referral } = this.props;
        return (
            <Container>
                <div style={{ padding: '6px', fontSize: '14px' }}>
                    <Row className="g-1">
                        <Col xs={4}>
                            <Button 
                                variant="link" 
                                size="sm" 
                                style={{ padding: '3px 6px', fontSize: '14px', textDecoration: 'underline' }}
                                onClick={this.openObservationsDialog}
                                disabled={!referral || !referral.id}
                            >
                                Observations <FontAwesomeIcon icon="paperclip" />
                            </Button>
                        </Col>
                        <Col xs={4}>
                            <Button 
                                variant="link" 
                                size="sm" 
                                style={{ padding: '3px 6px', fontSize: '14px', textDecoration: 'underline' }}
                                onClick={this.openObservationFromInsuranceDialog}
                                disabled={!referral || !referral.id}
                            >
                                Insurance Obs <FontAwesomeIcon icon="paperclip" />
                            </Button>
                        </Col>
                        <Col xs={4}>
                            <Button 
                                variant="link" 
                                size="sm" 
                                style={{ padding: '3px 6px', fontSize: '14px', textDecoration: 'underline' }}
                                onClick={this.openResubmissionsDialog}
                                disabled={!referral || !referral.id}
                            >
                                Resubmissions <FontAwesomeIcon icon="paperclip" />
                            </Button>
                        </Col>
                    </Row>
                    <Row className="g-1">
                        <Col xs={4}>
                            <Button 
                                variant="link" 
                                size="sm" 
                                style={{ padding: '3px 6px', fontSize: '14px', textDecoration: 'underline' }}
                                onClick={this.openRequestVersionsDialog}
                                disabled={!referral || !referral.requestVersionList}
                            >
                                Request Versions <FontAwesomeIcon icon="paperclip" />
                            </Button>
                        </Col>
                        <Col xs={4}>
                            <Button 
                                variant="link" 
                                size="sm" 
                                style={{ padding: '3px 6px', fontSize: '14px', textDecoration: 'underline' }}
                                onClick={this.openAuthorizationVersionsDialog}
                                disabled={!referral || !referral.authorizationVersionList}
                            >
                                Auth Versions <FontAwesomeIcon icon="paperclip" />
                            </Button>
                        </Col>
                        <Col xs={4}>
                            <div style={{ 
                                fontSize: '14px', 
                                color: (referral.denialCode && referral.denialCode !== 'N/A') ? '#dc3545' : '#6c757d',
                                fontWeight: (referral.denialCode && referral.denialCode !== 'N/A') ? 'bold' : 'normal',
                                padding: '3px 6px',
                                textAlign: 'left'
                            }}>
                                Denial Code: {referral.denialCode || 'N/A'}
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        );
    }
}

class Field extends Component {
    render() {
        const {label, body} = this.props;
        return <div style={{display: 'flex', alignItems: 'center', marginBottom: 8, gap: '10px'}}>
            <div><b>{label}:</b></div>
            <div>{body}</div>
        </div>;
    }
}